import { PartnerQueryStatus } from "./PartnerQueryStatus";
import { QueryDetailModel } from "./QueryDetailModel";
import { QueryStatus } from "./QueryStatus";
import { User } from "./user";

export class QueryModel
{
    Clarification_Query_Code: number = 0;
    Query_Reference_Number: string = '';

    Company_Code: number = 0;
    //Block_Code: number = 0;

    Requestor_Code: number = 0;
    Requestor_Name: string = '';
    
    Delete_Comment: string = '';
    Created_By: number = 0;
    IsReopendQuery: boolean = false;
    
    RequestorDetail: User = new User();

    QueryDetail: QueryDetailModel = new QueryDetailModel();
    CanViewPrevsQueryDtls: boolean = false;
    QueryStatus: string = '';
    QueryStatusEnum: QueryStatus = QueryStatus.New;
    PartnerQueryStatus: string = '';
    PartnerQueryStatusEnum: PartnerQueryStatus = PartnerQueryStatus.New;
    Created_Date: Date = new Date();
    Subject: string = '';
    
}